import {ElMessageBox} from "element-plus";

export default ElMessageBox.prompt